/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1NotificationMobileAppSharedEnrollmentTypes200,
  GetApiV1NotificationMobileAppSharedEnrollmentTypes401,
  GetApiV1NotificationMobileAppSharedEnrollmentTypesQueryResponse,
} from "../../types/notificationMobileAppController/GetApiV1NotificationMobileAppSharedEnrollmentTypes.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1NotificationMobileAppSharedEnrollmentTypes200Schema =
  z.array(
    z.lazy(() => dropDownListViewModelSchema),
  ) as unknown as ToZod<GetApiV1NotificationMobileAppSharedEnrollmentTypes200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1NotificationMobileAppSharedEnrollmentTypes401Schema =
  z.any() as unknown as ToZod<GetApiV1NotificationMobileAppSharedEnrollmentTypes401>;

export const getApiV1NotificationMobileAppSharedEnrollmentTypesQueryResponseSchema =
  z.lazy(
    () => getApiV1NotificationMobileAppSharedEnrollmentTypes200Schema,
  ) as unknown as ToZod<GetApiV1NotificationMobileAppSharedEnrollmentTypesQueryResponse>;
